"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSE_CLIENT_ERRORS = void 0;
const API_NAME = 'sse-client';
exports.SSE_CLIENT_ERRORS = Object.freeze({
    LISTEN_FAILED: `${API_NAME}/socket/listen-failed`,
    DISCONNECT_FAILED: `${API_NAME}/socket/disconnect-failed`,
});
